import { createEvent, createStore } from '@cobuildlab/react-simple-state';
import { AdminDisabledUser, GlobalUserExtraData, GlobalUserJoinSocialProvider, UserSubscriberEvent } from './user-types';
import { User } from '../../shared/types/generated';
import { ProviderCountData } from '../dashboard/dashboard-types';

export const fetchUserCountEvent = createEvent<{ count: number }>({
  initialValue: {
    count: 0,
  },
});

export const fetchUserCountErrorEvent = createEvent<Error>();

export const fetchDisableUsersEvent = createEvent<{ data: AdminDisabledUser[], total:number }>({
  initialValue: {
    data: [],
    total:0
  },
});

export const fetchDisableUsersErrorEvent = createEvent<Error>();

export const fetchEventsSubscriberEvent = createEvent<{ data: UserSubscriberEvent[], total:number }>({
  initialValue: {
    data: [],
    total:0
  },
});

export const fetchEventsSubscriberErrorEvent = createEvent<Error>();

export const fetchUserByProviderEvents = createEvent<
  ProviderCountData[]
>({
  initialValue: [],
});

export const fetchUserByProviderErrorEvents = createEvent<Error>();

export const fetchGlobalUsersEvent = createEvent<{
  data: GlobalUserJoinSocialProvider[];
  total: number;
}>({
  initialValue: {
    data: [],
    total: 0,
  },
});

export const fetchGlobalUsersErrorEvent = createEvent();

export const updateUserEvent = createEvent<{ user: User | undefined }>({
  initialValue: {
    user: undefined,
  },
});

export const updateUserErrorEvent = createEvent<Error>();

export const createUserInvitationDialogStore = createStore<{ isOpen: boolean }>(
  {
    initialValue: {
      isOpen: false,
    },
  },
);

export const fetchUserByMonthsEvents = createEvent<
  { count: number; date: string }[]
>({
  initialValue: [],
});

export const fetchUserByMonthsErrorEvents = createEvent<Error>();

export const fetchGlobalRegisterUsersEvent = createEvent<{
  data: GlobalUserJoinSocialProvider[];
  total: number;
}>({
  initialValue: {
    data: [],
    total: 0,
  },
});

export const fetchGlobalRegisterUsersErrorEvent = createEvent();


export const updateGlobalUserEvent = createEvent<void>();
export const updateGlobalUserEventError = createEvent<Error>();
export const updateGlobalUserExtraEvent = createEvent<void>();
export const updateGlobalUserExtraEventError = createEvent<Error>();

export const fetchGlobalUserEvent = createEvent<GlobalUserJoinSocialProvider>();
export const fetchGlobalUserEventError = createEvent<Error>();

export const fetchGlobalExtraUserEvent = createEvent<GlobalUserExtraData>();
export const fetchGlobalExtraUserEventError = createEvent<Error>();

export const cancelSubscriptionToAdminEvent = createEvent<void>();
export const cancelSubscriptionToAdminEventError= createEvent<Error>();